// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "webfontloader" + "." + "32e7c922" + ".js";
};